import exitIntent from 'exit-intent';

const rootSelector = '.c-modal';

window.modal_open = false;

function init() {
  const modal_selectors = document.querySelectorAll(rootSelector + '__selector');
  const modals = document.querySelectorAll(rootSelector + '__window');
  const modal_exits = document.querySelectorAll(rootSelector + '__close');
  
  if (!modal_selectors.length || !modals.length) {
    return;
  }
  // console.log("MODAL INITTED");
  
  exitIntent({
    threshold: 50,
    maxDisplays: 2,
    eventThrottle: 100,
    onExitIntent: () => {
      exitIntentPopup();
    }
  })
  
  // console.log("MODAL INITTED EXIT");
  // document.addEventListener("mouseout", onMouseOut);

  Array.from(modal_selectors).forEach((modal_selector) => {

    modal_selector.addEventListener('click', (e) => {
      if(typeof e.target.dataset.open !== "undefined")
      {
        window.$lightbox.trigger('to.owl.carousel', [e.target.dataset.open, 0])
      }
      open_modal(e);
    });

  });

  Array.from(modals).forEach((modal) => {

    modal.addEventListener('click', (e) => {
      close_modal(e);
    });

  });

  Array.from(modal_exits).forEach((modal_exit) => {

    modal_exit.addEventListener('click', (e) => {
      close_all_modals();
    });

  });

  setTimeout(function(){

    replace_button();

  }, 500);


}

function replace_button() {

  let form = document.querySelector(".c-form");
  let button = document.querySelector(".c-form__submit");
  if(button && form){
    let button_title = "<span class=\"c-button__title\">" + button.value + "</span>";
    let button_icon = form.querySelector(".c-button__icon");

    let new_button = document.createElement('button');
    new_button.className = "c-button c-button--icon c-button--blue c-button--inline";
    new_button.innerHTML = button_title;
    new_button.appendChild(button_icon);

    button.parentNode.replaceChild(new_button, button);

  }

}

function open_modal(e) {

  document.body.classList.add("is-modal");
  const modal_id = e.target.closest(rootSelector + '__selector').dataset.modal;
  const modal = document.querySelector("#c-modal__" + modal_id);
  modal.classList.add('active');
  modal_open = true;
  document.body.classList.add("modal");

}

function close_modal(e) {

  document.body.classList.remove("is-modal");
  if(e.target.classList.contains(rootSelector + '__window')) {

    const modals = document.querySelectorAll(rootSelector + '__window');
    Array.from(modals).forEach((modal) => {
      modal.classList.remove('active');
    });
    modal_open = false;

  }

}

function close_all_modals() {

  document.body.classList.remove("modal");

  const iframes = document.querySelectorAll('iframe');

  const modals = document.querySelectorAll(rootSelector + '__window');
  Array.from(modals).forEach((modal) => {
    modal.classList.remove('active');
  });
  modal_open = false;

  Array.from(iframes).forEach((iframe) => {
    if(!iframe) return 
    var player = new Vimeo.Player(iframe);

    player.pause().then(function() {
    // the video was paused
    }).catch(function(error) {
      switch (error.name) {
        case 'PasswordError':
          break;
        case 'PrivacyError':
          break;
        default:
          break;
      }
    });
  });

}

function exitIntentPopup() {
  // console.log("EXIT INTENT FIRED");

  document.body.classList.add("is-modal");
  const modal_id = "exit";
  const modal = document.querySelector("#c-modal__" + modal_id);

  // console.log("MODAL ID", modal_id);
  // console.log("MODAL NODE", modal);
  if(modal){

    modal.classList.add('active');
    modal_open = true;
    document.body.classList.add("modal");

  }

}

export default init;
